'use es6';

import { Component } from 'react';
import { connect } from 'react-redux';
import { getIsUngatedForImprovePlainTextFullWidthCSSResets } from 'EmailEditorUI/redux/selectors/AuthSelectors';
import { getOverrideableStylesheetContent, processStylesheet } from 'LayoutBuilderUI/utils/overrideableStyleSheetUtils';
import { getIsSingleColumnFullWidth } from 'EmailEditorUI/redux/selectors/styleSettingsSelectors';
const mapStateToProps = state => {
  const isUngatedForImprovePlainTextFullWidthCSSResets = getIsUngatedForImprovePlainTextFullWidthCSSResets(state);
  const isSingleColumnFullWidth = getIsSingleColumnFullWidth(state);
  return {
    overrideableStylesheetContent: getOverrideableStylesheetContent(state),
    shouldDisableResets: isUngatedForImprovePlainTextFullWidthCSSResets && isSingleColumnFullWidth
  };
};
class OverrideableStyles extends Component {
  componentDidMount() {
    this.replaceStylesheet();
    this.removeCustomizableMobileStyles();
    if (this.props.shouldDisableResets) {
      this.updateStyleResetsEnabled(this.props.shouldDisableResets);
    }
  }
  componentDidUpdate(prevProps) {
    this.replaceStylesheet();
    if (this.props.shouldDisableResets !== prevProps.shouldDisableResets) {
      this.updateStyleResetsEnabled(this.props.shouldDisableResets);
    }
  }
  updateStyleResetsEnabled(isDisabled) {
    const styles = [...document.querySelectorAll('[hs-reset-stylesheet="true"]')];
    styles.forEach(s => s.disabled = isDisabled);
  }
  replaceStylesheet() {
    const {
      overrideableStylesheetContent
    } = this.props;
    const styles = document.getElementById('overrideable_styles');
    processStylesheet(styles.innerHTML.concat(overrideableStylesheetContent), styles);
  }
  removeCustomizableMobileStyles() {
    document.querySelectorAll('[hs-customizable-mobile-styles="true"]').forEach(mobileSettingsStyleSheet => {
      mobileSettingsStyleSheet.remove();
    });
  }
  render() {
    return null;
  }
}
export default connect(mapStateToProps)(OverrideableStyles);